type FlightDataResponse = {
  data: {
    passenger_name?: string;
    outbound_flight_type: string;
    outbound_arrival_airport_code?: string;
    outbound_arrival_airport_name?: string;
    outbound_arrival_date: string;
    outbound_arrival_time: string;
    outbound_cabin?: string;
    outbound_departure_airport_code?: string;
    outbound_departure_airport_name?: string;
    outbound_departure_date: string;
    outbound_departure_time: string;
    outbound_duration_hours?: number;
    outbound_duration_minutes?: number;
    outbound_duration_time?: string;
    outbound_flight_number?: string;
    outbound_flight_pnr?: string;
    outbound_segments: Array<unknown>;
    outbound_order_number?: string;
    outbound_tail_number?: string;
    outbound_call_sign?: string;
    outbound_operator?: string;
    outbound_aircraft?: string;
    outbound_departure_location?: string;
    outbound_arrival_location?: string;
    outbound_handling_agents?: string;
    outbound_handling_agents_contact_number?: string;
    outbound_handling_agents_country_code?: string;
    outbound_departure_location_lat?: number;
    outbound_departure_location_lng?: number;
    outbound_arrival_location_lat?: number;
    outbound_arrival_location_lng?: number;
    return_flight_type?: string;
    return_arrival_airport_code?: string;
    return_arrival_airport_name?: string;
    return_arrival_date?: string;
    return_arrival_time?: string;
    return_cabin?: string;
    return_departure_airport_code?: string;
    return_departure_airport_name?: string;
    return_departure_date?: string;
    return_departure_time?: string;
    return_duration_hours?: number;
    return_duration_minutes?: number;
    return_duration_time?: string;
    return_flight_number?: string;
    return_flight_pnr?: string;
    return_segments: Array<unknown>;
    return_order_number?: string;
    return_tail_number?: string;
    return_call_sign?: string;
    return_operator?: string;
    return_aircraft?: string;
    return_departure_location?: string;
    return_arrival_location?: string;
    return_handling_agents?: string;
    return_handling_agents_contact_number?: string;
    return_handling_agents_country_code?: string;
  };
  error: null | boolean;
};

export type FlightFieldsToExtract = keyof FlightDataResponse["data"];

export const extractFlightInfoFromFile = async (file: File) => {
  const apiUrl = "https://dev-docextractor.blink.global/api/extract";
  const bearerToken = "doc_live_HTLBIBADeJkuEfbheFy7p3oV8VvrWvdy";

  const data = new FormData();
  data.append("files", file);
  data.append("extractor", "landing_ai");
  data.append("data_type", "flight");

  const response = await fetch(apiUrl, {
    method: "POST",
    body: data,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
    },
  });

  return (await response.json()) as FlightDataResponse;
};
